import http from '@/communication/AuthConnection'

export default (_id, eventData) => {
  return http.put(`/v1/event/${_id}`, eventData)
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/event/EditEvent.js